import { VehicleStatus } from '../../api-client/enums'
import getTimezoneOffset from '../../utils/get-timezone-offset'
import Hammer from '../svg/hammer'
import Circle from '../svg/circle'
import PurchaseTag from '../svg/purchase-tag'
import FinishFlag from '../svg/finish-flag'
import { format, isToday, parseISO, subHours } from '../../utils/date-service'

export default function AuctionStatusRibbon({ status, auctionStartDate, timeZone, reserveIsMet }) {
  const zonedAuctionStartDateToLocal = subHours(
    parseISO(auctionStartDate, { withTime: true }),
    getTimezoneOffset(timeZone, auctionStartDate),
  )

  return (
    <div className='wrapper flex alignCenter'>
      {status === VehicleStatus.ApprovedForAuction && !isToday(zonedAuctionStartDateToLocal) && (
        <>
          <Hammer className='leftAdornment' /> {format(zonedAuctionStartDateToLocal, 'd MMM')}
        </>
      )}
      {status === VehicleStatus.ApprovedForAuction && isToday(zonedAuctionStartDateToLocal) && (
        <>
          <Hammer className='leftAdornment' /> Today!
        </>
      )}
      {status === VehicleStatus.OnLiveAuction && (
        <>
          <Hammer className='leftAdornment' /> Live <Circle className='rightAdornment' />
        </>
      )}
      {status === VehicleStatus.ApprovedForBuyNow && (
        <>
          <PurchaseTag className='leftAdornment' /> Buy Now
        </>
      )}
      {(status === VehicleStatus.CompletedFromAuction ||
        status === VehicleStatus.CompletedFromBuyNow) &&
        reserveIsMet && (
          <>
            <PurchaseTag className='leftAdornment' /> SOLD
          </>
        )}
      {(status === VehicleStatus.CompletedFromAuction ||
        status === VehicleStatus.CompletedFromBuyNow) &&
        !reserveIsMet && (
          <>
            <FinishFlag className='leftAdornment' /> Finished
          </>
        )}

      <style jsx>{`
        .wrapper {
          color: #fff;
          font-weight: 700;

          :global(.leftAdornment) {
            fill: #fff;
            width: 2.2rem;
            margin: 0 0.85rem 0 0;
          }

          :global(.rightAdornment) {
            fill: var(--alert-color);
            width: 2.2rem;
            margin: 0 0 0 0.85rem;
          }
        }
      `}</style>
    </div>
  )
}
